if (!customElements.get('compare-recipient')) {
  class CompareRecipient extends HTMLElement {
    constructor() {
      super();

      this.handleChangeRef = this.handleChange.bind(this);
    }

    handleChange() {
      document.dispatchEvent(new CustomEvent('alexa:compare-recipient:change', { detail: { isMatching: this.recipient.value == this.confirmRecipient.value && this.recipient.validity.valid && this.confirmRecipient.validity.valid } }));
    }

    disconnectedCallback() {
      this.removeEventListener('input', this.handleChangeRef);
    }

    connectedCallback() {
      this.recipient = this.querySelector('[data-recipient]');
      this.confirmRecipient = this.querySelector('[data-confirm-recipient]');

      this.addEventListener('input', this.handleChangeRef);
    }
  }

  customElements.define('compare-recipient', CompareRecipient);
}
